import React, { useState, useEffect } from "react";
import "./SubtitleUploadModal.css";
import { useVideo } from "../../context/VideoContext";
import { getMainLanguageOptions } from "../../utils/languages";

const SubtitleUploadModal = ({ files, onClose, onConfirm }) => {
  const { videoMetadata } = useVideo(); // این خط رو اضافه کنید
  const [config, setConfig] = useState([]);
  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    const initialConfig = files.slice(0, 2).map((file, index) => ({
      file,
      subtitleNumber: index + 1,
      language: index === 0 ? "en" : "fa",
    }));

    setConfig(initialConfig);
  }, [files]);

  const handleConfirm = (config) => {
    // قبل از فراخوانی onConfirm، متادیتا رو اضافه می‌کنیم
    const configWithMetadata = config.map((item) => ({
      ...item,
      movieFileName: videoMetadata?.fileName, // اضافه کردن نام فایل فیلم
    }));

    onConfirm(configWithMetadata);
  };

  useEffect(() => {
    const allSelected = config.every((c) => c.subtitleNumber && c.language);
    setIsValid(allSelected);
  }, [config]);

  const updateConfig = (index, field, value) => {
    const newConfig = [...config];
    newConfig[index][field] = value;
    setConfig(newConfig);
  };

  return (
    <div
      className="subtitle-modal-overlay"
      onClick={(e) => {
        e.stopPropagation();
        // setShowSettings(false);
      }}
    >
      <div className="subtitle-modal">
        <h2>انتخاب تنظیمات زیرنویس</h2>

        {config.map((item, index) => (
          <div key={index} className="subtitle-item">
            <div className="file-name">{item.file.name}</div>

            <div className="field">
              <label>شماره زیرنویس:</label>
              <select
                value={item.subtitleNumber}
                onChange={(e) =>
                  updateConfig(index, "subtitleNumber", Number(e.target.value))
                }
              >
                <option value={1}>زیرنویس ۱</option>
                <option value={2}>زیرنویس ۲</option>
              </select>
            </div>

            <div className="field">
              <label>زبان:</label>
              <select
                value={item.language}
                onChange={(e) =>
                  updateConfig(index, "language", e.target.value)
                }
              >
                {getMainLanguageOptions().map((lang) => (
                  <option key={lang.code} value={lang.code}>{lang.name}</option>
                ))}
              </select>
            </div>
          </div>
        ))}

        <div className="actions">
          <button onClick={onClose}>لغو</button>
          <button disabled={!isValid} onClick={() => handleConfirm(config)}>
            ادامه
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubtitleUploadModal;
